import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { setActivityRepeat } from 'store/entities/activity/actions'
import { getActivityId, activityIsRepeating } from 'store/entities/activity/selectors'

import ActivityRepeatButton from './ActivityRepeatButton'

const mapStateToProps = state => ({
  isActivityRepeating: activityIsRepeating(state),
  activityId: getActivityId(state),
})

const mapDispatchToProps = {
  setActivityRepeat,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('user')(ActivityRepeatButton))
